import React from "react";

import { Box } from "@mui/material";

import { Tribuja } from "../../assets";

const HeroSectionMain: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",

        height: {
          xs: "80vh",
          md: "100vh",
        },

        overflow: "hidden",

        // ================= BACKGROUND IMAGE =================

        backgroundImage: {
          xs: `url("https://dprstorage.b-cdn.net/RW/leadgen/tri3.png")`, // MOBILE BG
          md: `url("https://dprstorage.b-cdn.net/RW/leadgen/tri2.png")`, // DESKTOP BG
        },

        backgroundSize: "cover",

        backgroundPosition: {
          xs: "center",
          md: "center",
        },

        backgroundRepeat: "no-repeat",

        // ================= FIXED BG =================

        backgroundAttachment: {
          xs: "scroll",
          md: "fixed",
        },

        position: "relative",
      }}
    />
  );
};

export default HeroSectionMain;